(function($) {
  
  $(document).ready(function() {
    
  });
  
})(jQuery);

function initCardHorizontal(){
  var $ = jQuery;
  $('body').on('click', '.js-locked-post', function(e){
    e.preventDefault();
    $('body').addClass('is-popup-lockedpost-shown');
    $('body').addClass('is-overlay-visible');
    return false;
  })
  if(getQueryVariable('postlocked') == '1'){
    $('body').addClass('is-popup-lockedpost-shown');
    $('body').addClass('is-overlay-visible');
  }

 /* $('.m-card-horizontal').css('height','auto');
  $(window).on('resize',function(){
    //console.log('x');
    $('.m-card-horizontal').each(function(){
      var h = $(this).parent().attr('card-h');
      if(!h){h = 0;}
      $(this).attr('card-h',$(this).height());
      if($(this).height() > h){
        $(this).parent().attr('card-h',$(this).height());
      }
    })
    $('.m-card-horizontal').each(function(){
      $(this).css('height',$(this).parent().attr('card-h'));
    })
  }).trigger('resize')

  window.setTimeout(function(){
    $(window).trigger('resize');
  },1000)*/
}